interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
  ogUrl?: string;
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonical,
  ogTitle,
  ogDescription,
  ogType = "website",
  ogUrl,
}: SEOHeadProps) {
  const resolvedOgTitle = ogTitle || title;
  const resolvedOgDesc = ogDescription || description;
  const resolvedUrl = ogUrl || canonical;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      {canonical && <link rel="canonical" href={canonical} />}
      <meta
        name="last-modified"
        content={new Date().toISOString().split("T")[0]}
      />
      <meta property="og:title" content={resolvedOgTitle} />
      <meta property="og:description" content={resolvedOgDesc} />
      <meta property="og:type" content={ogType} />
      {resolvedUrl && <meta property="og:url" content={resolvedUrl} />}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={resolvedOgTitle} />
      <meta name="twitter:description" content={resolvedOgDesc} />
    </>
  );
}
